module.exports = __webpack_public_path__ + "static/img/wealth_level_95.e71c6b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_95.png
// module id = eIAE
// module chunks = 0